import React from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { Button as ButtonRaw } from '@sparebankenvest/splash-ui';
import {
  Input,
  Select,
} from './Forms';
import i18n from '../i18n';
import Borettslagsleilighet from './Borettslagsleilighet';
import { normalizeMoney } from '../format.util';

const MIN_AGE = 60;
const MAX_AGE = 105;

const Button = styled(ButtonRaw)`
  margin-top: 40px;
`;

const OmDeg = ({ borettslagsleilighet }) => (
  <>
    <div>
      <Field
        name="boligverdi"
        type="tel"
        label={i18n(i => i.BOLIGVERDI_LABEL)}
        component={Input}
        format={normalizeMoney}
        rightInlineElement={() => <span>kr</span>}
        transformableLabel={false}
      />
    </div>
    <Borettslagsleilighet borettslagsleilighet={borettslagsleilighet} />
    <div>
      <Field
        name="laantakerAlder"
        label={i18n(i => i.HOVEDLAANTAKER_ALDER_LABEL)}
        component={Select}
        transformableLabel={false}
      >
      <option value="">Velg alder</option>
      {Array(MAX_AGE - MIN_AGE + 1).fill()
        .map((_, index) => MIN_AGE + index).map(
          year => (
            <option value={year} key={`${year}hovedlaantaker`}>
              {year} år
            </option>
          ),
        )}
      </Field>
    </div>
    <div>
      <Field
        name="medlaantakerAlder"
        label={i18n(i => i.MEDLAANTAKER_ALDER_LABEL)}
        component={Select}
        transformableLabel={false}
      >
        <option value="">Velg alder</option>
        {Array(MAX_AGE - MIN_AGE + 1).fill()
          .map((_, index) => MIN_AGE + index).map(
            year => (
              <option value={year} key={`${year}medlaantaker`}>
                {year} år
              </option>
            ),
        )}
      </Field>
    </div>
    <Button type="submit">
      Beregn hva du kan få
    </Button>
  </>
);

export default OmDeg;